"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizedAccountRoles = exports.RiskLevels = exports.CashAccountStatuses = exports.AccountStatuses = exports.BrokerDealerVerificationStatuses = exports.UpdateRequiredTypes = exports.AccreditationStatuses = exports.VerificationSubStatuses = exports.VerificationStatuses = exports.VerificationLevels = exports.InvestorTypes = exports.Genders = void 0;
exports.Genders = {
    MALE: 'male',
    FEMALE: 'female',
};
exports.InvestorTypes = {
    ENTITY: 'entity',
    INDIVIDUAL: 'individual',
};
exports.VerificationLevels = {
    NONE: 'none',
    STANDARD: 'standard',
    ENHANCED: 'enhanced',
};
exports.VerificationStatuses = {
    NONE: 'none',
    PROCESSING: 'processing',
    UPDATES_REQUIRED: 'updates-required',
    VERIFIED: 'verified',
    MANUAL_REVIEW: 'manual-review',
    REJECTED: 'rejected',
    EXPIRED: 'expired',
};
exports.VerificationSubStatuses = {
    EXPIRED: 'expired',
    DOCUMENTS_EXPIRED: 'documents-expired',
    ENHANCE_REQUESTED: 'enhance-requested',
    BLOCKED: 'blocked',
    NONE: 'none',
};
exports.AccreditationStatuses = {
    NONE: 'none',
    PROCESSING: 'processing',
    VERIFIED: 'verified',
    REJECTED: 'rejected',
    NOT_ACCREDITED: 'not-accredited',
    PENDING: 'pending',
    EXPIRED: 'expired',
    UPDATES_REQUIRED: 'updates-required',
};
exports.UpdateRequiredTypes = {
    ADDITIONAL_LEGAL_SIGNERS: 'additional-legal-signers',
    ADDITIONAL_DOCUMENTATION: 'additional-documentation',
    LEGAL_SIGNERS_MISSING_INFO: 'legal-signers-missing-info',
    COMMENT_TO_INVESTOR_COMMENT: 'comment-to-investor-comment',
};
exports.BrokerDealerVerificationStatuses = {
    NONE: 'none',
    PROCESSING: 'processing',
    VERIFIED: 'verified',
    NOT_APPROVED: 'not-approved',
};
exports.AccountStatuses = {
    NONE: 'none',
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
exports.CashAccountStatuses = {
    NONE: 'none',
    OPENED_WITH_SID: 'opened-with-sid',
    OPENED_WHIT_BD: 'opened-with-bd',
};
exports.RiskLevels = {
    NONE: 'none',
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
};
exports.AuthorizedAccountRoles = {
    ADMIN: 'admin',
    VIEWER: 'viewer',
    RESTRICTED_SIGNER: 'restricted-signer',
};
//# sourceMappingURL=investors.js.map